import {createApp} from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementPlus from 'element-plus'
import SvgIconPlugin from '@/plugins/SvgIconPlugin'
// import locale from 'element-plus/lib/locale/lang/zh-cn' // 测试环境打包使用
import locale from 'element-plus/es/locale/lang/zh-cn' // 生产环境打包和本地使用
import 'element-plus/dist/index.css'

const app = createApp(App);

app.use(store)
    .use(router)
    .use(ElementPlus, {locale})
    .use(SvgIconPlugin, {imports: []})
    .mount('#app')
